<template>
  <div>
    <v-stepper v-if="!!config && dataReady" alt-labels v-model="stepModel">
      <v-stepper-header>
        <v-stepper-step :complete="stepModel > 1" step="1">
          {{ $t('Datos de la empresa') }}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="stepModel > 2" step="2">
          {{ $t('Comprobaciones previas') }}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="stepModel > 3" step="3">
          {{ $t('Registro de actividades de tratamientos') }}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="stepModel > 4" step="4">
          {{ $t('Otros datos de interés') }}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="5">{{ $t('Finalizar') }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content v-if="stepModel === 1" step="1">
          <h2>{{ $t('Datos de la empresa') }}</h2>
          <opendata-company-data
            disabled
            :validate-before-submit="false"
            :model="formModel.company"
            :config="config"
            @companySaved="companySaved"
          ></opendata-company-data>
          <!-- <opendata-wizard-step disabled :validate-before-submit="false"  :saving-data="savingData" :key="stepModel"
                        :model="formModel.company" :step="stepModel" :config="config"
                        @wizardStepSubmit="nextStep" @wizardPrevStep="previousStep"></opendata-wizard-step> -->
        </v-stepper-content>

        <v-stepper-content v-if="stepModel === 2" step="2">
          <h2>{{ $t('Comprobaciones previas') }}</h2>

          <opendata-wizard-step
            disabled
            :validate-before-submit="false"
            :saving-data="savingData"
            :key="stepModel"
            :model="formModel.formData[stepModel]"
            :step="stepModel"
            :config="config"
            @wizardStepSubmit="nextStep"
            @wizardPrevStep="previousStep"
          ></opendata-wizard-step>
        </v-stepper-content>

        <v-stepper-content v-if="stepModel === 3" step="3">
          <opendata-wizard-step
            disabled
            :validate-before-submit="false"
            :saving-data="savingData"
            :title="$t('Registro de actividades de tratamientos')"
            :key="stepModel"
            :model="formModel.formData[stepModel]"
            :step="stepModel"
            :config="config"
            @wizardStepSubmit="nextStep"
            @wizardPrevStep="previousStep"
          ></opendata-wizard-step>
        </v-stepper-content>

        <v-stepper-content v-if="stepModel === 4" step="4">
          <opendata-wizard-step
            disabled
            :validate-before-submit="false"
            :saving-data="savingData"
            :title="$t('Otros datos de interés')"
            :key="stepModel"
            :model="formModel.formData[stepModel]"
            :step="stepModel"
            :config="config"
            @wizardStepSubmit="nextStep"
            @wizardPrevStep="previousStep"
          ></opendata-wizard-step>
        </v-stepper-content>

        <v-stepper-content v-if="stepModel === 5" step="5">
          <opendata-wizard-step
            disabled
            :validate-before-submit="false"
            :saving-data="savingData"
            :title="$t('Finalizar')"
            :key="stepModel"
            :model="formModel.formData[stepModel]"
            :step="stepModel"
            :config="config"
            :submit-text="$t('Cerrar')"
            @wizardStepSubmit="closeDialog"
            @wizardPrevStep="previousStep"
          ></opendata-wizard-step>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import OpendataCompanyData from '@/modules/opendata/components/wizard/OpendataCompanyData.vue';
import OpendataWizardStep from '@/modules/opendata/components/wizard/OpendataWizardStep.vue';

export default {
  components: {
    OpendataCompanyData,
    OpendataWizardStep,
  },

  props: {
    config: {
      type: Object,
    },

    entity: {
      type: Object,
    },
  },
  data() {
    return {
      stepModel: 1,
      dataReady: false,
      savingData: false,
      scrollOptions: {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic',
      },
      formModel: {
        company: {},
        formData: {},
      },
    };
  },

  computed: {
    opendataId() {
      return this.formModel.company && this.formModel.company.id
        ? this.formModel.company.id
        : 'new';
    },
  },
  mounted() {
    if (this.entity) {
      this.dataReady = false;
      this.formModel.company = {
        id: this.entity['id'] ? this.entity['id'] : null,
        clavedat: this.entity['clavedat'] ? this.entity['clavedat'] : null,
        name: this.entity['name'] ? this.entity['name'] : null,
        cif: this.entity['cif'] ? this.entity['cif'] : null,
        address: this.entity['address'] ? this.entity['address'] : null,
        city: this.entity['city'] ? this.entity['city'] : null,
        postal_code: this.entity['postal_code'] ? this.entity['postal_code'] : null,
        province: this.entity['province'] ? this.entity['province'] : null,
        phone: this.entity['phone'] ? this.entity['phone'] : null,
        email: this.entity['email'] ? this.entity['email'] : null,
        activity: this.entity['activity'] ? this.entity['activity'] : null,
      };

      this.formModel.formData = this.entity['form_data'] ? this.entity['form_data'] : {};

      this.dataReady = true;
    } else {
      this.dataReady = true;
    }

    console.log({ formModel: this.formModel });
  },
  methods: {
    companySaved(company) {
      this.formModel.company = company;
      this.stepModel = 2;
      this.scrollToTop();
    },
    nextStep(data) {
      this.stepModel = this.stepModel + 1;
      this.scrollToTop();
    },
    previousStep(data) {
      this.stepModel = this.stepModel - 1;
      this.scrollToTop();
    },
    closeDialog() {
      this.$emit('close');
      this.scrollToTop();
    },
    scrollToTop() {
      this.$vuetify.goTo(0, this.scrollOptions);
    },
  },
};
</script>

<style></style>
